import styled from "@emotion/styled";
import { StyledAnimatedSkeleton } from "shared/components/ModuleSkeleton/components/ModuleHeaderSkeleton/styled";
import { COLOR_BORDER, COLOR_PRIMARY_BACKGROUND } from "shared/theme/colors";

export const SkeletonCard = styled(StyledAnimatedSkeleton)`
  height: 124px;
  width: 175px;
`;

export const FavoriteCard = styled("div")`
  width: 175px;
  height: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 3px dashed ${COLOR_BORDER};
  background-color: ${COLOR_PRIMARY_BACKGROUND};
`;
